/* eslint-disable sonarjs/cognitive-complexity */

import React from 'react';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

import { BaSeIcon } from '@base/react';
import { cardsSegredos } from '../../data/cardsSegredos';
import { useDisplay } from '../../hook/useDisplay';
import Modal from './Modal';
import {
  AlignText,
  Container,
  ContainerMobile,
  ContainerText,
  Content,
  ContentItem,
  ContentText,
  RoundButton
} from './style';
import './style.css';

function Secrets() {

  const [linkSelected, setLinkSelected] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const { isLargeDisplay } = useDisplay();

  function CustomArrow(props) {
    const { className, style, onClick, direction } = props;
    return (
      <RoundButton
        className={className}
        style={{ ...style, display: 'hidden' }}
        onClick={onClick}
      >
        <BaSeIcon
          name={`system/arrow-${direction}-s-line`}
          size="18"
          description="icon-lightulb-als"
          color="#0000c9"
        />
      </RoundButton>
    );
  }

  React.useEffect(() => {
    const timer = setTimeout(() => {
      const divSelected = document.getElementById("4");

      if (!divSelected) return;

      const slickDots = divSelected.querySelector('.slider-container ul.slick-dots');

      if (!slickDots) return;

      slickDots.style.display = 'flex';
      slickDots.style.bottom = '-40px';
      slickDots.style.justifyContent = 'center';
      slickDots.style.alignItems = 'center';
      slickDots.style.gap = '15px';
      slickDots.style.padding = '0';
      slickDots.style.marginTop = '0';

      const updateDotsStyles = () => {
        const dots = slickDots.querySelectorAll('li > div');

        dots.forEach((div) => {
          const parentLi = div.parentElement;

          if (parentLi.classList.contains('slick-active')) {
            div.style.backgroundColor = 'black';
            div.style.width = '30px';
            div.style.margin = '0 10px';
          } else {
            div.style.backgroundColor = 'rgb(139, 153, 167)';
            div.style.width = '15px';
            div.style.margin = '0 20px';
          }
        });
      };

      updateDotsStyles();

      const observer = new MutationObserver(updateDotsStyles);

      observer.observe(slickDots, {
        childList: true,
        attributes: true,
        subtree: true,
      });

      return () => {
        observer.disconnect();
      };
    }, 100);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    nextArrow: <CustomArrow direction="right" />,
    prevArrow: <CustomArrow direction="left" />,

    customPaging: (i) => (
      <div
        style={{
          height: '5px',
          borderRadius: 100,
          backgroundColor: '#8B99A7',
        }}
      >
        ‎
      </div>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          centerPadding: "50px",

        }
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
          centerPadding: "50px",
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: false,
          centerPadding: "50px",

        }
      }
    ]
  };
  return (
    <Container id="4">
      <ContainerText>
        <p>
          Descubra os <strong>segredos</strong> para manter o seu negócio no
          caminho certo
        </p>
      </ContainerText>
      {
        isLargeDisplay()
          ? (
            <div style={{ padding: '0 20px' }}>
              <div className="slider-container">
                <Slider {...settings}>
                  {cardsSegredos.map((item) => (
                    <ContentItem key={item.title}>
                      <Content bg={item.imgCard}>
                        <ContentText>
                          <AlignText>
                            <BaSeIcon
                              color="#fff"
                              description="Ícone de play"
                              name="media/play-mini-fill"
                              onClick={() => {
                                setOpen((prev) => !prev);
                                setLinkSelected(item.linkVideoCard);
                              }}
                              size={52}
                            />
                          </AlignText>
                          <p>{item.title}</p>
                        </ContentText>
                      </Content>
                    </ContentItem>
                  ))}
                </Slider>
              </div>
            </div>
          ) : (
            <ContainerMobile>
              {cardsSegredos.map((item) => (
                <ContentItem key={item.title}>
                  <Content bg={item.imgCard}>
                    <ContentText>
                      <AlignText>
                        <BaSeIcon
                          color="#fff"
                          description="Ícone de play"
                          name="media/play-mini-fill"
                          onClick={() => {
                            setOpen((prev) => !prev);
                            setLinkSelected(item.linkVideoCard);
                          }}
                          size={52}
                        />
                      </AlignText>
                      <p>{item.title}</p>
                    </ContentText>
                  </Content>
                </ContentItem>

              ))}
            </ContainerMobile>

          )
      }
      <div>
      </div>
      <Modal open={open} link={linkSelected} onClose={() => setOpen(false)} />
    </Container>
  );
}

export default Secrets;
